<template>
  <v-container>
    <v-form ref="form" class="">
      <div style="background-color: #ffff">
        <div class="ml-3 pt-3 font-weight-bold">
          {{ translations.label_basic_information }}
        </div>
        <v-row class="ma-2">
          <v-col cols="6">
            <v-text-field
              :rules="nameRule"
              v-model="form.name"
              :label="translations.label_name"
            ></v-text-field>
            <v-text-field
              :rules="emailRule"
              v-model="form.email"
              :label="translations.email_label"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :rules="lastNameRule"
              v-model="form.lastName"
              :label="translations.label_last_name"
            ></v-text-field>
            <label class="v-label theme--light" style="font-size: 12px">
              {{ translations.label_phone }}
            </label>
            <vue-tel-input
              ref="phoneInput"
              v-model="form.phone"
              v-bind="telOptions"
              @onInput="onPhoneInput"
              class="custom-tel-input"
            ></vue-tel-input>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.password"
              :label="translations.prompt_password"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="ma-3 font-weight-bold">
          {{ translations.label_address }}
        </div>
        <v-row class="ma-2">
          <v-col cols="12">
            <v-text-field
              v-model="form.street"
              :label="translations.label_street"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.intNumber"
              :label="translations.label_interior_number"
            ></v-text-field>
            <v-text-field
              v-model="form.suburb"
              :label="translations.label_neighborhood"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.extNumber"
              :label="translations.label_exterior_number"
            ></v-text-field>
            <v-text-field
              v-model="form.zipCode"
              :label="translations.label_postal_code"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.city"
              :label="translations.label_city"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.state"
              :label="translations.label_state"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="form.country"
              :label="translations.label_country || 'País'"
              :items="standardCountries"
              :item-text="(item) => item[currentLanguage] || item.es"
              item-value="val"
              clearable
              :rules="[validationCountry]"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </div>
    </v-form>
    <!-- copyright -->
    <v-footer class=" text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </v-container>
</template>

<script>
// Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
// Validations
import {
  requiredValidation,
  emailValidation,
  numberValidation,
} from "@/helpers/validations.js";
import standardCountries from "@/constants/countries.json";

export default {
  data: () => ({
    standardCountries,
    form: {
      name: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      street: "",
      intNumber: "",
      extNumber: "",
      suburb: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
    },
    //rules
    nameRule: null,
    lastNameRule: null,
    emailRule: null,
    phoneRule: null,
  }),
  created() {
    this.nameRule = requiredValidation(this.translations.advice_error);
    this.lastNameRule = requiredValidation(this.translations.advice_error);
    this.emailRule = emailValidation(this.translations.advice_error);
    this.phoneRule = requiredValidation(this.translations.advice_error);
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goToTerritory,
      rightButton: "save",
      funcRightButton: this.saveProfile,
    });

    var user = JSON.parse(localStorage.getItem("user"));
    this.form.name = user.name;
    this.form.lastName = user.lastName;
    this.form.email = user.email;
    this.form.phone = user.phone;
    this.form.street = user.address.street;
    this.form.intNumber = user.address.interiorNumber;
    this.form.extNumber = user.address.exteriorNumber;
    this.form.suburb = user.address.suburb;
    this.form.zipCode = user.address.zipCode;
    this.form.city = user.address.city;
    this.form.state = user.address.state;
    this.form.country = user.address.country || "";
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("session", ["SET_DATA_PROFILE"]),
    ...mapActions("profile", ["updateProfile"]),
    ...mapMutations("profile", ["SET_PROFILE"]),
    goToTerritory() {
      this.$router.back();
    },
    onPhoneInput(formatted, phoneObject) {
      if (phoneObject && phoneObject.number) {
        this.form.phone = phoneObject.number.e164 || formatted;
      }
    },
    validationCountry(value) {
      if (!value) return true;
      const isValid = this.standardCountries.some((c) => c.val === value);
      return isValid || "País no válido";
    },
    async saveProfile() {
      // Forzar el formato internacional antes de guardar
      if (this.$refs.phoneInput && this.$refs.phoneInput.phoneObject) {
        const { number } = this.$refs.phoneInput.phoneObject;
        if (number && number.e164) {
          this.form.phone = number.e164;
        }
      }
      try {
        if (this.$refs.form.validate()) {
          this.SET_LOADER(true);
          let address = {
            street: this.form.street,
            interiorNumber: this.form.intNumber,
            exteriorNumber: this.form.extNumber,
            suburb: this.form.suburb,
            zipCode: this.form.zipCode,
            city: this.form.city,
            state: this.form.state,
            country: this.form.country,
          };
          this.form.address = address;
          let response = await this.updateProfile(this.form);

          if (response.status == 200) {
            this.SET_DATA_PROFILE(response.data);
            var flag = this.getDataProfile;
            this.SET_PROFILE(!flag);
            this.goToTerritory();
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        }
      } catch (error) {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.SET_LOADER(false);
    },
  },
  computed: {
    ...mapGetters("profile", ["getDataProfile"]),
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    telOptions() {
      return {
        mode: "international",
        defaultCountry: "MX",
        inputOptions: {
          placeholder: this.translations.label_phone || "",
          showDialCode: true,
        },
      };
    },
  },
};
</script>
<style scoped>
.custom-tel-input {
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 4px !important;
  min-height: 40px !important;
  background-color: white !important;
  margin-top: 8px !important;
  margin-bottom: 12px !important;
  padding: 5px 12px !important;
  font-family: "Noto Sans", sans-serif !important;
  font-size: 14px !important;
}
.custom-tel-input:focus-within {
  border: 2px solid #238d27 !important;
  padding: 4px 11px !important; /* Ajuste por el borde de 2px */
}
/* Estilos internos de vue-tel-input */
::v-deep .vti__input {
  background: transparent !important;
  border: none !important;
}
</style>
